var _window$requestAnimat;

/**
 * Created by 白 on 2014/8/5.
 */
import * as LinkedList from './linked-list.js';
var timeout = null;
var tasks = LinkedList.LinkedList();
export var requestAnimationFrame = (_window$requestAnimat = window.requestAnimationFrame) !== null && _window$requestAnimat !== void 0 ? _window$requestAnimat : function (callback) {
  return setTimeout(callback, 1000 / 60);
};
export var requestFrame = window.requestAnimationFrame ? function (task) {
  var goOn = true;

  function _start() {
    if (goOn) {
      task();
      requestAnimationFrame(_start);
    }
  }

  requestAnimationFrame(_start);
  return {
    start: function start() {
      goOn = true;

      _start();
    },
    remove: function remove() {
      goOn = false;
    }
  };
} : function (task) {
  var node = null;

  function start() {
    // 如果任务没有添加进链表,添加到链表中
    if (node === null) {
      node = tasks.insert(task, null); // 如果当前没有计时,开始计时

      if (timeout === null) {
        timeout = setTimeout(function frame() {
          var cur;

          if (tasks.tail() !== null) {
            timeout = setTimeout(frame, 1000 / 60);

            for (cur = tasks.head(); cur !== null; cur = cur.next) {
              cur();
            }
          } else {
            timeout = null;
          }
        }, 1000 / 60);
      }
    }
  }

  start();
  return {
    start: start,
    remove: function remove() {
      node && tasks.remove(node);
      node = null;
    }
  };
};